import { render, staticRenderFns } from "./top-lang.vue?vue&type=template&id=5e77ef98&scoped=true"
import script from "./top-lang.vue?vue&type=script&lang=js"
export * from "./top-lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e77ef98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e77ef98')) {
      api.createRecord('5e77ef98', component.options)
    } else {
      api.reload('5e77ef98', component.options)
    }
    module.hot.accept("./top-lang.vue?vue&type=template&id=5e77ef98&scoped=true", function () {
      api.rerender('5e77ef98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/top/top-lang.vue"
export default component.exports